<template>
  <ux-form
    ref="form"
    :data="formData"
    :rules="rules"
    width="570px"
    :colon="true"
    label-width="100px"
    data-automation="addProduct"
    @close="close"
    @confirm="confirm"
  >
    <ux-form-item :label="$t('HT.unbindApi.name')" prop="name">
      <ux-input
        v-model="formData.name"
        :maxlength="30"
        :placeholder="$t('HT.addApply.name.placeholder')"
      ></ux-input>
    </ux-form-item>
    <ux-form-item :label="$t('HT.productAll.type')" prop="type">
      <ux-select
        v-model="formData.type"
        :options="productTypes"
        :props="{ label: 'name', value: 'id' }"
        :placeholder="$t('HT.rules.addAccess.type')"
      ></ux-select>
    </ux-form-item>
    <ux-form-item :label="$t('HT.addProduct.remark')" start prop="remark">
      <ux-input
        v-model="formData.remark"
        type="textarea"
        :autosize="{ minRows: 5, maxRows: 5 }"
        resize="none"
        :maxlength="180"
        show-word-limit
        :placeholder="$t('HT.addProduct.placeholder')"
      ></ux-input>
    </ux-form-item>
  </ux-form>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      default: () => {
        return {
          name: '',
          type: '',
          remark: ''
        };
      }
    }
  },
  created() {
    this.getProductTypes();
  },
  data() {
    return {
      formData: JSON.parse(JSON.stringify(this.data)),
      rules: this.$rul.addProduct(),
      productTypes: []
    };
  },

  methods: {
    /**
     * 取消回调
     */
    close() {
      this.$uxModal.hide();
    },

    /**
     * 确认回调
     */
    confirm() {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.$emit('confirm', this.formData);
        }
      });
    },
    getProductTypes() {
      this.$api.product.getAllProductType().then(res => {
        this.productTypes = res.data;
      });
    }
  }
};
</script>

